import CONFIG from '../config';
import moment from 'moment';

export const poll = (fn: () => boolean, timeout: number, interval: number) => {
  var endTime = Number(new Date()) + (timeout || 2000);
  interval = interval || 100;

  var checkCondition = function (resolve: any, reject: any) {
    // If the condition is met, we're done!
    var result = fn();
    if (result) {
      resolve(result);
    }
    // If the condition isn't met but the timeout hasn't elapsed, go again
    else if (Number(new Date()) < endTime) {
      setTimeout(checkCondition, interval, resolve, reject);
    }
    // Didn't match and too much time, reject!
    else {
      reject(new Error('timed out for ' + fn + ': ' + arguments));
    }
  };

  return new Promise<boolean>(checkCondition);
};

export const getSeeAllGamesLink = (): string => {
  if (window.location.host.indexOf('store') < 0) {
    return '';
  }

  return CONFIG.isUPC
    ? `/upc/${CONFIG.countryCode}/uplayplus-games?lang=${CONFIG.lang}`
    : `/${CONFIG.countryCode}/uplayplus/games?lang=${CONFIG.lang}`;
};

export const formatLocale = (locale: string) => {
  return locale.replace('_', '-');
};

export const sendEvent = (action: string, additionalParams: any = {}) => {
  // @ts-ignore
  if (typeof window.tc_events_100 !== 'undefined') {
    // @ts-ignore
    window.tc_events_100(this, 'clickevent', {
      ACTION: action,
      ...additionalParams
    });
  }
};

export const fetchDisplayPrice = (product: any) => {
  if (!product) {
    return null;
  }

  if (
    window.productsPromotions &&
    window.productsPromotions[product.id] &&
    moment.utc(window.productsPromotions[product.id].expirationDateUTC) >
      moment()
  ) {
    return {
      // @ts-ignore
      regular: window.productsPromotions[product.id].regularPrice,
      // @ts-ignore
      promotionalPrice: window.productsPromotions[product.id].promotionalPrice
    };
  }
  return product.displayPrice;
};

export const getImageFileName = (image: string) => {
  const extensionRegex = /(.*)\.(jpg|gif|png|jpeg)/gi;
  const matches = extensionRegex.exec(image);
  const filename = matches[1];

  return filename;
};
